import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { IconPin, IconPinCC, IconPinned, IconUnpin } from '../../../base/icons/svg';
import { getParticipantById, isLocalParticipantModerator } from '../../../base/participants/functions';
import BaseIndicator from '../../../base/react/components/web/BaseIndicator';
import { getPinnedActiveParticipants, isStageFilmstripAvailable } from '../../functions.web';
import { pinParticipant } from '../../../base/participants';
import { addStageParticipant, removeStageParticipant } from '../../actions.web';
import { sendCommand } from '../../../mod-command/slice';
import { COMMANDS } from '../../../mod-command/constants';
import { getModCommand } from '../../../mod-command/functions';
import { openDialog } from '../../../base/dialog/actions';
import DialogPinAllParticipants from '../../../video-menu/components/web/DialogPinAllParticipants';
const useStyles = makeStyles()(() => {
    return {
        pinnedIndicator: {
            padding: '4px',
            zIndex: 3,
            display: 'inline-block',
            borderRadius: '4px',
            boxSizing: 'border-box',
            '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, .7)',
            },
            '& svg': {
                fill: 'none !important'
            }
        },
        hoverDefault: {
            cursor: 'default',
            '&:hover': {
                backgroundColor: 'transparent'
            }
        }
    };
});
/**
 * Thumbnail badge showing that the participant would like to speak.
 *
 * @returns {ReactElement}
 */
const PinnedIndicator = ({ iconSize, participantId, tooltipPosition, pinAll, disabled }) => {
    const stageFilmstrip = useSelector(isStageFilmstripAvailable);
    const pinned = useSelector((state) => getParticipantById(state, participantId))?.pinned;
    const activePinnedParticipants = useSelector(getPinnedActiveParticipants);
    const isPinned = activePinnedParticipants.find(p => p.participantId === participantId);
    const { classes: styles, cx } = useStyles();
    const dispatch = useDispatch();
    const pinnedAllPariticipantId = useSelector((state) => getModCommand(state, COMMANDS.PIN_PARTICIPANT.COMMAND)?.value);
    const isLocalModerator = useSelector((state) => isLocalParticipantModerator(state));
    if (disabled)
        return (React.createElement("div", { className: cx(styles.pinnedIndicator, disabled && styles.hoverDefault, 'pin-indicator'), id: `pin-indicator-${participantId}` },
            React.createElement(BaseIndicator, { icon: IconPin, iconSize: `${iconSize}px`, tooltipKey: 'videothumbnail.pinned', tooltipPosition: tooltipPosition })));
    if (!isLocalModerator && pinAll) {
        return React.createElement(React.Fragment, null);
    }
    if (((stageFilmstrip && !isPinned && !pinAll) || (!stageFilmstrip && !pinned && !pinAll))
        ||
            ((stageFilmstrip && pinAll && pinnedAllPariticipantId !== participantId) || (!stageFilmstrip && pinAll && pinnedAllPariticipantId !== participantId))) {
        const _icon = pinAll ? IconPinCC : IconPin;
        return (React.createElement("div", { className: styles.pinnedIndicator, id: `pin-indicator-${participantId}`, onClick: () => {
                if (pinAll) {
                    dispatch(openDialog(DialogPinAllParticipants, { participantId }));
                }
                else {
                    dispatch(pinParticipant(participantId));
                    dispatch(addStageParticipant(`${participantId}`, true));
                }
            } },
            React.createElement(BaseIndicator, { icon: _icon, iconSize: `${iconSize}px`, tooltipKey: pinAll ? 'videothumbnail.pinToAll' : 'videothumbnail.pinToStage', tooltipPosition: tooltipPosition })));
    }
    const _icon = pinAll ? IconUnpin : IconPinned;
    return (React.createElement("div", { className: styles.pinnedIndicator, id: `pin-indicator-${participantId}`, onClick: () => {
            if (pinAll) {
                dispatch(sendCommand(COMMANDS.UN_PIN_PARTICIPANT.COMMAND, activePinnedParticipants[0]?.participantId, true));
            }
            else {
                dispatch(pinParticipant(""));
                dispatch(removeStageParticipant(`${participantId}`));
            }
        } },
        React.createElement(BaseIndicator, { icon: _icon, iconSize: `${iconSize}px`, tooltipKey: pinAll ? 'videothumbnail.unpinFromAll' : 'videothumbnail.unpinFromStage', tooltipPosition: tooltipPosition })));
};
export default PinnedIndicator;
